<template>
  <div>
    <!-- This is a layout for multiple radio groups -->
    <!-- It uses a table of radio groups with question text above -->
    <div v-for="(enu,iindex) in enums" :key="enu.id" mb-5>
      <h3 class="blue-text">{{ enu.title }}</h3>
      <v-radio-group v-model="enu.which" v-bind:column="!radiosInRow" class="blue-text">
        <v-radio
          v-for="oindex in indexRange(iindex)"
          :key="oindex"
          :value="oindex"
          v-on:change="setSelection(iindex,oindex)"
        >
          <template slot="label">
            <h4 class="blue-text">{{ options(iindex)[oindex].text }}</h4>
          </template>
        </v-radio>
      </v-radio-group>
    </div>
    <!-- Debug tools -->
    <v-card flat v-if="showTools">
      <v-card-actions>
        <v-btn text @click="applySavedValues">Apply saved values</v-btn>
        <v-btn text @click="clear">Clear</v-btn>
        <v-btn text v-for="(option, index) in [0, 1, 2]" :key="index" @click="setTo(index)">To {{index}}</v-btn>
        <v-card-text>userSet = {{ userSets }};  value = {{ values }}</v-card-text>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style >
@import "../assets/styles/styles.css";
</style>

<script>
import { overrideQuestionModel } from "../model/override-question-model.js";
import { range } from "../utils/std.js";

function doBreak() {
  // eslint-disable-next-line no-debugger
  //debugger;
}

export default {
  name: "ScoresQuestion",
  props: {
    qid: String,
    showTools: Boolean
  },
  data() {
    return {}
  },
  computed: {
    radiosInRow() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    question() {
      return overrideQuestionModel.getEnrichedQuestion(this.qid);
    },
    enums() {
      return this.$store.getters.getChildEnums(this.qid).sort(e => e.index)
    },
    userSets() {
      return this.enums.map(e => e.userSet)
    },
    values() {
      return this.enums.map(e => e.which)
    }
  },
  methods: {
    indexRange(iindex) {
      doBreak();
      return range(0, this.options(iindex).length - 1)
    },
    options(iindex)  {
      return this.question.items[iindex].options;
    },
    setSelection(itemIndex, valueIndex) {
      const e = this.enums[itemIndex]
      //e.value = valueIndex;
      this.$store.commit("setEnum", { id: e.id, index: valueIndex, userSet: true });
      // If all flags are known, update the UI
      if (this.$store.getters.getQuestionAllUserSet(this.qid)) {
        this.$emit('completed', itemIndex);        
      }
    },
    // Test methods
    applySavedValues() {
      this.$store.commit('applySavedValues', {whichSet: 1})
    },
    clear() {
      this.enums.forEach(e => {
        this.$store.commit("clearEnum", { id: e.id });
      })
    },
    setTo(index) {
      this.enums.forEach(e => {
        this.$store.commit("setEnum", { id: e.id, index: index, userSet: false });
      })
    }
  }
};
</script>
